<template>
  <div class="row">
    <div class="col-12">
      <div class="intro__headline-wrapper">
        <h1 class="intro__headline">      
              Pomóż pszczołom, zostań Pszczelim Bohaterem (lub Bohaterką) i
              zdobądź wspaniałe upominki!        
          <a href="#scrollTo"><div class="intro__arrow"><span></span><span></span><span></span></div></a>
        </h1>
      </div>
      <div class="about__box pt-5 pt-lg-2">
      <div id="scrollTo" class="d-none d-md-block"></div>
      <div class="intro__content pt-lg-2 ">
        Tylko działając razem możemy zrobić coś naprawdę dobrego dla tych
        pozytecznych owadów. Już dziewiąty rok wspólnie dbamy o to, by żyło się
        im w Polsce lepiej. Tym razem łączymy siły, by zadbać o dom leśnych
        zapylaczy, czyli tych owadów, które związane są z lasem. Jak w innych
        ekosystemach, tak i w lesie zapylacze są podstawą różnorodności
        biologicznej. I to właśnie dzięki nim możemy na przykład cieszyć się
        dorodniejszymi i smaczniejszymi malinami, jeżynami czy jagodami.
        Pozbawione szkodliwej chemii środowisko leśne to szansa na przetrwanie
        owadów zapylających i poprawę ich kondycji. Dlatego adoptuj pszczoły,
        pomagaj owadom i twórz z nami Polskę (i lasy!) przyjazną wszystkim
        zapylaczom.
      </div>
      <div class="d-none d-lg-block text-center"></div>
      <div>
        <Slider />
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import Slider from "./Slider.vue";

export default {
  name: "Intro",
  data() {
    return {
      title: "Introduction",
    };
  },
  components: {
    Slider,
  },
};
</script>
